import Shared from './shared';
import * as config from './test_acc_prod.json';

const Config = Object.assign(Shared, config);

export default Config;
